import {
  styled,
  Card as BaseCard,
  Button as BaseButton,
  Typography,
} from '@material-ui/core'

export const Card = styled(BaseCard)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(4, 3.8),
  boxShadow: 'none',
  height: '100%',
}))

export const InfoContainer = styled('div')({})

export const Highlight = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 35,
  fontWeight: 600,
  marginRight: theme.spacing(),
  marginBottom: theme.spacing(0.5),
}))

export const PaymentDateContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  fontSize: 17,
  fontWeight: 400,
}))

export const Bold = styled('span')(({ theme }) => ({
  marginRight: theme.spacing(),
  fontWeight: 600,
}))

export const DaysLeftContainer = styled('div')({
  display: 'flex',
  fontSize: 18,
  fontWeight: 400,
  alignItems: 'center',
  whiteSpace: 'nowrap',
})

export const ButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(3),
}))

export const Button = styled(BaseButton)({
  fontWeight: 600,
  fontSize: 16,
  width: 'max-content',
})

export const EndsToday = styled(Typography)({
  fontSize: 24,
  fontWeight: 600,
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
})

export const Link = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 700,
  textDecoration: 'none',
}))
